var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"camera"},[_c('img',{class:{
      'd-flex': !_vm.isLoading,
      'd-none': _vm.isLoading
    },attrs:{"id":_vm.videoElementId,"width":"100%","height":"100%","src":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }